<template>
    <div class="o-jargonCards u-w100 u-py20 u-overflowYAuto" ref="scrollContainer">
        <div class="o-jargonCards_inner u-container u-overflowHidden">
            <div class="o-jargonCards__articles">
                <div v-for="module in jargonCards" :key="module.module_title" class="o-jargonCards__module">
                    <div class="o-jargonCards__group u-mb20" v-if="module.jargoncards && module.jargoncards.length > 0">
                        <h2 class="o-jargonCards__title u-colorSecondary">{{ module.module_title }}</h2>
                        <div v-for="jargoncard in module.jargoncards" :key="jargoncard.title" class="o-jargonCards__item">
                            <JargonCard :item="jargoncard" />
                        </div>
                    </div>
                </div>

                <div v-if="noMoreJargonCards" class="no-more-jargon-cards">{{ $t('knowledgebase.noMoreJargonCards') }}</div>
                <div ref="trigger" class="o-jargonCards__trigger u-mt50"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import api from '../services/api';
import JargonCard from '../components/molecules/JargonCard.vue'

const jargonCards = ref([]);
const noMoreJargonCards = ref(false);
const offset = ref(0);
const number = ref(3);
const loading = ref(false);
const observer = ref(null);
const trigger = ref(null);
const scrollContainer = ref(null);

const loadMoreJargonCards = async () => {
    if (loading.value || noMoreJargonCards.value) {
        return false;
    }

    loading.value = true;
    try {
        const response = await api.get(`/jargon-cards?offset=${offset.value}&number=${number.value}`);

        if (response.data.message) {
            noMoreJargonCards.value = true;
            return false;
        } else {
            jargonCards.value.push(...response.data);
            offset.value += number.value;
            return true;
        }
    } catch (error) {
        console.error('Error loading jargon cards:', error);
        return false;
    } finally {
        loading.value = false;
    }
};

const setupObserver = () => {
    if (observer.value) {
        observer.value.disconnect();
    }

    if (!scrollContainer.value) {
        console.error("Error: scrollContainer ref is null. Cannot set up IntersectionObserver root.");
        return;
    }
    if (!trigger.value) {
        console.error("Error: trigger ref is null. Cannot observe trigger element.");
        return;
    }

    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loading.value && !noMoreJargonCards.value) {
            loadMoreJargonCards();
        }
    }, {
        root: scrollContainer.value,
        rootMargin: '0px',
        threshold: 0.1
    });

    observer.value.observe(trigger.value);
};

onMounted(async () => {
    let loadedSuccessfully = await loadMoreJargonCards();

    if (loadedSuccessfully && !noMoreJargonCards.value) {
        await nextTick();
        await new Promise(resolve => setTimeout(resolve, 50));

        if (scrollContainer.value) {
            while (!noMoreJargonCards.value && !loading.value && scrollContainer.value.scrollHeight <= scrollContainer.value.clientHeight) {
                loadedSuccessfully = await loadMoreJargonCards();
                await nextTick();
                if (!loadedSuccessfully) break;
            }
        } else {
            console.error("Scroll container not available after initial render. Cannot perform fill loop.");
        }
    }

    await new Promise(resolve => setTimeout(resolve, 100));
    await nextTick();
    setupObserver();
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});
</script>
